
import React, { memo } from 'react';
import { Button } from '@/components/ui/button';
import { useLocation } from 'react-router-dom';
import { LayoutDashboard, BookOpen, Users } from 'lucide-react';

interface NavButtonsProps {
  onNavigate: (path: string) => void;
}

const navItems = [
  {
    icon: <LayoutDashboard className="h-4 w-4" />,
    label: "Dashboard",
    path: "/dashboard",
  },
  {
    icon: <BookOpen className="h-4 w-4" />,
    label: "Journal",
    path: "/journal",
  },
  {
    icon: <Users className="h-4 w-4" />,
    label: "Groups",
    path: "/groups",
  },
];

export const NavButtons = memo(({ onNavigate }: NavButtonsProps) => {
  const location = useLocation();
  
  return (
    <>
      {navItems.map((item) => (
        <Button
          key={item.path}
          variant={location.pathname === item.path ? "default" : "outline"}
          size="sm"
          onClick={() => onNavigate(item.path)}
          className={`win95-button flex items-center gap-2 text-xs md:text-sm px-2 md:px-3 py-1 md:py-2 h-7 md:h-8 ${
            location.pathname === item.path
              ? "bg-blue-500 text-white"
              : "hover:bg-gray-200"
          }`}
        >
          {item.icon}
          <span className="hidden sm:inline">{item.label}</span>
        </Button>
      ))}
    </>
  );
});

NavButtons.displayName = 'NavButtons';
